import { useMemo } from 'react';
import centers from '../data/centers';

export function useCurrentCenter() {
    const currentCenterName = process.env.REACT_APP_CENTER_NAME;

    const currentCenter = useMemo(() => {
        if (!Array.isArray(centers)) return null;

        return centers.find(c => c.nombre === currentCenterName) || null;
    }, [currentCenterName]);

    return currentCenter;
}